module.exports = __webpack_public_path__ + "staticVue/img/logo-dv.2faedde2.png";